$(function() {
  // Determine if the length unit is imperial.
  const imperial = $('form.edit_alternative').data('lengthUnit') === 'imperial';

  // Converts the input value, multiplying by 25.4 if imperial, then sets it on the CAD element.
  function convert(elem, cad_elem) {
    let value = elem.val();
    if (imperial) {
      value *= 25.4;
    }
    cad_elem.val(value);
    return value;
  }

  // Converts pocket size strings to numeric codes.
  function pocket_size(elem, cad_elem) {
    let value = elem.val();
    switch (value) {
      case '0x0':
        value = '0';
        break;
      case '100x50':
        value = '1';
        break;
      case '130x75':
        value = '2';
        break;
      case '150x105':
        value = '3';
        break;
      case '210x150':
        value = '4';
        break;
    }
    cad_elem.val(value);
  }

  // Converts pocket position strings to numeric codes.
  function pocket_position(elem, cad_elem) {
    let value = elem.val();
    switch (value) {
      case 'Top':
        value = '1';
        break;
      case 'Bottom':
        value = '2';
        break;
      case 'FS':
        value = '3';
        break;
      case 'FC':
        value = '4';
        break;
      case 'FS + FC':
        value = '5';
        break;
    }
    cad_elem.val(value);
  }

  // --- Rack ---
  $('#cad_alternative_ii_rack_inner_w').on('keyup', function() {
    convert($(this), $('#cad_alternative_cad_bayiw'));
  });

  $('#cad_alternative_ii_rack_inner_d').on('keyup', function() {
    convert($(this), $('#cad_alternative_cad_bayid'));
  });

  $('#cad_alternative_ii_rack_inner_h').on('keyup', function() {
    convert($(this), $('#cad_alternative_cad_bayih'));
  });

  $('#cad_alternative_ii_rack_inner_sb').on('keyup', function() {
    convert($(this), $('#cad_alternative_cad_suspspaceback'));
  });

  $('#cad_alternative_ii_rack_inner_sf').on('keyup', function() {
    convert($(this), $('#cad_alternative_cad_suspoffsetfrontd'));
  });

  // --- Beam ---
  $('#cad_alternative_ii_beam_h').on('keyup', function() {
    convert($(this), $('#cad_alternative_cad_beamheight'));
  });

  $('#cad_alternative_ii_beam_d').on('keyup', function() {
    convert($(this), $('#cad_alternative_cad_beamwidth'));
  });

  $('#cad_alternative_ii_beamsteph').on('keyup', function() {
    convert($(this), $('#cad_alternative_cad_beamsteph'));
  });

  $('#cad_alternative_ii_beamstepd').on('keyup', function() {
    convert($(this), $('#cad_alternative_cad_beamstepd'));
  });

  // Set beam type code.
  $('#cad_alternative_i_beamtype').on('change', function() {
    let value = 'R';
    if ($(this).val() === 'stepped beam') {
      value = 'S';
    }
    $('#cad_alternative_cad_beamtype').val(value);
  });

  // --- Pocket Sizes ---
  $('#cad_alternative_i_p1_labelx_size').on('change', function() {
    pocket_size($(this), $('.label-size-a'));
  });

  $('#cad_alternative_i_p1_labely_size').on('change', function() {
    pocket_size($(this), $('.label-size-a'));
  });

  $('#cad_alternative_i_p2_labelx_size').on('change', function() {
    pocket_size($(this), $('.label-size-b'));
  });

  $('#cad_alternative_i_p2_labely_size').on('change', function() {
    pocket_size($(this), $('.label-size-b'));
  });

  $('#cad_alternative_i_p3_labelx_size').on('change', function() {
    pocket_size($(this), $('.label-size-c'));
  });

  $('#cad_alternative_i_p3_labely_size').on('change', function() {
    pocket_size($(this), $('.label-size-c'));
  });

  $('#cad_alternative_i_p4_labelx_size').on('change', function() {
    pocket_size($(this), $('.label-size-d'));
  });

  $('#cad_alternative_i_p4_labely_size').on('change', function() {
    pocket_size($(this), $('.label-size-d'));
  });

  // --- Pocket Positions ---
  $('#cad_alternative_i_p1_lab_pos').on('change', function() {
    pocket_position($(this), $('#cad_alternative_cad_sglabelpos_a'));
  });

  $('#cad_alternative_i_p2_lab_pos').on('change', function() {
    pocket_position($(this), $('#cad_alternative_cad_sglabelpos_b'));
  });

  $('#cad_alternative_i_p3_lab_pos').on('change', function() {
    pocket_position($(this), $('#cad_alternative_cad_sglabelpos_c'));
  });

  $('#cad_alternative_i_p4_lab_pos').on('change', function() {
    pocket_position($(this), $('#cad_alternative_cad_sglabelpos_d'));
  });
});
